import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M13 13l-3-2.25L7 13V4H6v16h12V4h-5z",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 4h2v5l-1-.75L9 9V4zm9 16H6V4h1v9l3-2.25L13 13V4h5v16z"
})), 'BookTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/BookTwoTone.js
// module id = 2392
// module chunks = 2